import styled from "styled-components";

export default styled.div`

&{
  width: 100%;
  height: 100%;
}

main{
  display: flex;
  flex-wrap: wrap;
}

tr{
  cursor: pointer;
}

td{
  vertical-align: middle;
}

.go-back{
  margin-top: 20px;
  margin-bottom: 20px;
}

.delete{
  margin: 0;
}

.btn-create{
  margin: 0 10px;
  height: 100%;
}

.action {
  display:flex;
  justify-content: center;
  align-items: center;
  color: ${props => props.theme.colors.black};
  margin-left:50%;
}
.icon {
  width: ${props => props.theme.spacing.spacing_08};
  height:  ${props => props.theme.spacing.spacing_06};
}

`